export function getAllUnexpectedStockOutflowStatus(unexpectedStockOutflowStatusRepository) {
    return unexpectedStockOutflowStatusRepository.getAll();

}

export default getAllUnexpectedStockOutflowStatus;